import {TextSearchFilterComponent} from './text-search-filter/text-search-filter.component';
import {JobDepartment} from '../../api/models/job-department';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {CacheDataService} from '../../api/services/cache-data.service';
import {AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, forwardRef, Input, NgZone, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {JobSeniority} from '../../api/models/job-seniority';

@Component({
  selector: 'job-seniority-search',
  templateUrl: './text-search-filter/text-search-filter.component.html',
  styleUrls: ['./text-search-filter/text-search-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JobSenioritySearchComponent),
      multi: true
    }
  ]
})
export class JobSenioritySearchComponent extends TextSearchFilterComponent<JobSeniority> implements ControlValueAccessor, OnInit, AfterViewInit
{
  @ViewChild('scrollDiv') scrollDiv : ElementRef;
  @Input() dataChanged: () => void = () => {};
  @Input() fixedHeight?: number;
  @Input() showSelected: boolean = false;

  @Output() dataLoadComplete = new EventEmitter<void>();

  constructor(cacheDataService: CacheDataService, ngZone: NgZone) {
    super(cacheDataService, ngZone);
  }

  protected dataUpdated() {
    this.dataChanged();
  }

  protected getShowSelected(): boolean {
    return this.showSelected;
  }

  protected getHeightValue() : number | undefined {
    if (this.fixedHeight) {
      return this.fixedHeight;
    }
    return undefined;
  }

  ngOnInit() {
    this.callNgOnInit();
  }

  ngAfterViewInit() {
    this.callNgAfterViewInit();
  }

  protected getDivScroller(): ElementRef {
    return this.scrollDiv;
  }

  protected isSelected(target: JobSeniority) : boolean {
    const exists = this._value && this._value.selectedValues && this._value.selectedValues.find(x => x.seniorityId === target.seniorityId);
    return !!exists;

  }

  protected getDisplay(target: JobSeniority): string {
    return target.seniority;
  }

  protected async newSearch() {
    this.reloading = true;

    const result = await this.cacheDataService.cacheDataSearchJobSeniorities({pageNumber: 1, pageSize: 100, search: this._value?.searchTerms ?? []}).toPromise();

    this.currentPage = 1;
    this.totalPages = result.totalPages;
    this.sourceValues = result.page;

    this.reloading = false;
    this.dataLoadComplete.emit();
  }

  protected async getNextBatch() {
    if (this.currentPage < this.totalPages) {
      this.loading = true;
      this.currentPage++;

      const result = await this.cacheDataService.cacheDataSearchJobSeniorities({pageNumber: this.currentPage, pageSize: 100, search: this._value?.searchTerms ?? []}).toPromise();

      this.totalPages = result.totalPages;
      this.loading = false;
      this.sourceValues = [...this.sourceValues, ...result.page];
      this.dataLoadComplete.emit();
    }
  }

  protected getSearchPlaceholder(): string {
    return 'Search Seniorities...';
  }
}
